"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _get = _interopRequireDefault(require("lodash/get"));
var _InstrumentTableComponent = _interopRequireDefault(require("./InstrumentTableComponent"));
var _instrumentPositionSelectors = require("../../redux/selectors/instrumentPositionSelectors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  var _products$find;
  var selectedInstrument = (0, _instrumentPositionSelectors.selectedInstrumentSelector)(state);
  var _ref = state.apexCore ? state.apexCore : {},
    level1 = _ref.level1;
  var selectedInstrumentId = (0, _get["default"])(selectedInstrument, 'InstrumentId', '');
  var products = state.apexCore.product.products;
  var decimalPlacesP2 = ((_products$find = products.find(function (product) {
    return product.ProductId === selectedInstrument.Product2;
  })) === null || _products$find === void 0 ? void 0 : _products$find.DecimalPlaces) || 8;
  return {
    level1: level1[selectedInstrumentId],
    selectedInstrument: selectedInstrument,
    decimalPlacesP2: decimalPlacesP2
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, null)(_InstrumentTableComponent["default"]);